import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import playersReducer from "./store/playerSlice";
import groupReducer from "./store/groupSlice";
import recordReducer from "./store/recordSlice";
import bettingTableReducer from "./store/bettingTableSlice";
import userReducer from "./store/userSlice";
import userBuyInLogReducer from "./store/userBuyInLogsSlice";

export const store = configureStore({
  reducer: {
    players: playersReducer,
    groups: groupReducer,
    records: recordReducer,
    bettingTable: bettingTableReducer,
    user: userReducer,
    userBuyInLog: userBuyInLogReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
